import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { CustomHttpResponse, ClientInvoiceFee } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ClientInvoiceFeeService {
  apiService: ApiHttpService<ClientInvoiceFee> = inject(ApiHttpService<ClientInvoiceFee>);

  getByIri(iri: string): Observable<ClientInvoiceFee> {
    return this.apiService.get(iri).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientInvoiceFee>) => result.body),
    );
  }

  getById(id: string): Observable<ClientInvoiceFee> {
    return this.apiService.get(`/client_invoice_fees/${id}`).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientInvoiceFee>) => result.body),
    );
  }

  create(clientInvoiceFee: ClientInvoiceFee): Observable<ClientInvoiceFee> {
    return this.apiService
      .post(`/client_invoice_fees`, clientInvoiceFee)
      .pipe(map((result: CustomHttpResponse<ClientInvoiceFee>) => result.body));
  }

  getClientInvoiceFeesForClientInvoice(iri: string): Observable<ClientInvoiceFee[]> {
    return this.apiService.getMany(`${iri}/client_invoice_fees`).pipe(map((result) => result.body['hydra:member']));
  }

  update(iri: string, updatedRecord: Record<string, string | number | null | undefined>): Observable<ClientInvoiceFee> {
    return this.apiService.patch(iri, updatedRecord as unknown as ClientInvoiceFee).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientInvoiceFee>) => result.body),
    );
  }

  delete(iri: string) {
    return this.apiService.delete(iri).pipe(map((result) => result));
  }
}
